import React from "react";

interface PasskeyCreatedInfoProps {
  publicKeyX?: string;
  publicKeyY?: string;
  credentialId?: string;
  walletAddress?: string;
  onClose?: () => void;
}

export function PasskeyCreatedInfo(_props: PasskeyCreatedInfoProps) {
  return <div className="text-sm text-muted-foreground">Passkey ready</div>;
}
